import React, { useState, useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { createPortal } from 'react-dom';
import { currentDomain, currentPath } from '../Index';
import { usePromotionsData } from '../data/PromotionData';
import { useNavigate } from 'react-router-dom';
import useAppPromotionTheme from '../hooks/useAppPromotionTheme';
import MasterGamesList from '../data/MasterGamesList';
import RiseOfHeroesGame from '../snippets/games/RiseOfHeroesGame';
import ScrollLoader from '../snippets/games/ScrollLoader';
import ModuleEvoThrone from './promotion_modules/ModuleEvoThrone';

export default function EvoThrone({ isLightMode }) {
    const isAppPromo = useAppPromotionTheme(isLightMode);
    const { promotionsData, isPromotionDataReady } = usePromotionsData();
    const data = useMemo(
        () => promotionsData.find((promo) => promo.title === 'Evo Throne'),
        [promotionsData]
    );
    const [isMobile, setIsMobile] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [loading, setLoading] = useState(true);
    const [showGame, setShowGame] = useState(false);
    const [activeModal, setActiveModal] = useState('');
    const navigate = useNavigate();

    const modalComponents = {
        'Evo Throne': ModuleEvoThrone,
    };

    const ActiveModal = activeModal ? modalComponents[activeModal] : null;

    const handleEvoThrone = () => {
        if (!isLoggedIn) {
            window.location.href = '/promotion';
        } else {
            setActiveModal('Evo Throne');
        }
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 841);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const loggedInState = localStorage.getItem('isLoggedIn') === 'true';
        setIsLoggedIn(loggedInState);
    }, []);

    // If the promo page is expired - throws error
    useEffect(() => {
        if (!isPromotionDataReady) return;

        if (!data) {
            navigate('/not-found');
        }
    }, [isPromotionDataReady, data, navigate]);

    if (!isPromotionDataReady || !data) return null;

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Evo Throne</title>
                <link rel="icon" href="/images/fav.webp" sizes="32x32" />
                <meta name="description" content="ddd" />
                <link rel="canonical" href={`${currentDomain}${currentPath}`} />
            </Helmet>
            <div className="promotion-page-main all-page-main-container-min-height">
                <div className="promotion-page-container main-container-global-adjusted-padding">
                    <div className="promotion-tnc-page">
                        <div className="promotion-page-breadcrumb">
                            <a
                                href={
                                    isAppPromo
                                        ? '/promotion/'.replace(
                                              '/promotion',
                                              '/app-promotion'
                                          )
                                        : '/promotion/'
                                }
                            >
                                Promotions
                            </a>
                            / <span>{data.title}</span>
                        </div>
                        <div className="promotion-tnc-banner">
                            <img
                                src={isMobile ? data.imgSrc : data.bannerSrc}
                                alt={`FGH${data.title}`}
                            />
                        </div>
                        <div className="promotion-tnc-content">
                            <div className="promotion-tnc-info">
                                <div
                                    className={`promotion-indication-message ${data.promotionMessage.class}`}
                                >
                                    {data.promotionMessage.text}
                                </div>
                                <h1>EVO Throne: Live to Rule</h1>
                                <h2>
                                    Take Your Seat. Rule the Tables. Claim the
                                    Throne.
                                </h2>
                                <div className="promotion-tnc-period">
                                    <strong> Event Period: </strong>
                                    <span> Oct 05 - Nov 02, 2026 </span>
                                </div>
                            </div>
                            <div className="promotion-tnc-mechanic-content">
                                {isLoggedIn && !isAppPromo && (
                                    <div className="promotion-tnc-btn-wrapper">
                                        <button
                                            className="promotion-cta-btn"
                                            onClick={handleEvoThrone}
                                        >
                                            Leaderboard
                                        </button>
                                    </div>
                                )}
                                <strong>Promo Mechanics</strong>

                                <ol>
                                    <li>
                                        The EVO Throne: Live to Rule promotion
                                        is open to all registered FGH players
                                        with active accounts.
                                    </li>
                                    <li>
                                        To begin your journey to the throne,
                                        play any eligible Evolution Live Dealer
                                        games available on the FGH website
                                        during the promo period.
                                    </li>
                                    <li>
                                        Players must accumulate a minimum valid
                                        turnover of PHP 5,000 during the weekly
                                        qualifying period to earn a place in the
                                        Royal Leaderboard.
                                    </li>
                                    <li>
                                        Only the strongest rulers will rise to
                                        the top. The Top 10 players with the
                                        highest valid turnover each week will
                                        earn their place on the EVO Throne and
                                        receive exclusive rewards.
                                    </li>
                                    <li>
                                        Royal Competition Period:
                                        <ul style={{ marginBottom: '0px' }}>
                                            <li>
                                                Starts every Monday at 12:00 PM
                                                (GMT+8)
                                            </li>
                                            <li>
                                                Ends the following Monday at
                                                11:59 AM (GMT+8)
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        Coronation Day (Prize Awarding):
                                        <ul style={{ marginBottom: '0px' }}>
                                            <li>
                                                Winners will be crowned and
                                                prizes credited every Monday by
                                                3:00 PM (GMT+8).
                                            </li>
                                            <li>
                                                All rewards will be credited as
                                                Free Credits with no rollover
                                                requirement.
                                            </li>
                                            <div className="table-wrapper">
                                                <table
                                                    className="promotion-tnc-table"
                                                    style={{
                                                        minWidth: '0px',
                                                    }}
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th>Rank</th>
                                                            <th>
                                                                Free Credits
                                                            </th>
                                                            <th>
                                                                No. of Winner
                                                            </th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                1st (King of the
                                                                Table)
                                                            </td>
                                                            <td>8,000.00</td>
                                                            <td>1</td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                2nd (Royal
                                                                Challenger)
                                                            </td>
                                                            <td>5,000.00</td>
                                                            <td>1</td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                3rd (Table
                                                                Noble)
                                                            </td>
                                                            <td>3,000.00</td>
                                                            <td>1</td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                4th - 5th (Royal
                                                                Court)
                                                            </td>
                                                            <td>1,000.00</td>
                                                            <td>2</td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                6th - 10th
                                                                (Throne
                                                                Contenders)
                                                            </td>
                                                            <td>500.00</td>
                                                            <td>5</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </ul>
                                    </li>
                                    <li>
                                        Only valid and settled bets placed on
                                        eligible Evolution Live Dealer games
                                        will count toward the Royal Leaderboard.
                                        Cancelled, voided, refunded, or
                                        unsettled bets will not be considered.
                                    </li>
                                    <li>
                                        Any form of opposite betting, collusion,
                                        or unfair gameplay is strictly
                                        prohibited. Players found attempting to
                                        manipulate results will be stripped of
                                        their rank and disqualified from the
                                        promotion.
                                    </li>
                                    <li>
                                        In the event of a tie, the player who
                                        reaches the qualifying turnover first
                                        will be awarded the higher rank on the
                                        leaderboard.
                                    </li>
                                    <li>
                                        FGH reserves the right to verify all
                                        gameplay activity and determine the
                                        final rankings.
                                    </li>
                                    <li>
                                        FGH reserves the right to amend,
                                        suspend, extend, or terminate the
                                        promotion at any time without prior
                                        notice.
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showGame &&
                createPortal(
                    loading ? (
                        <ScrollLoader />
                    ) : (
                        <RiseOfHeroesGame onClose={() => setShowGame(false)} />
                    ),
                    document.body
                )}

            {ActiveModal && (
                <ActiveModal closeModal={() => setActiveModal('')} />
            )}
        </>
    );
}
